export interface Developer {
  id: number;
  email: string;
  username: string;
  first_name: string;
  last_name: string;
  profile_picture_url?: string | null;
}

export interface ComponentManager {
  id: number;
  component: {
    id: number;
    name: string;
    description?: string;
  };
  description?: string;
  version?: string;
  lead_developer?: Developer;
  backup_developer?: Developer;
  created_at: string;
  updated_at: string;
}

let cache: ComponentManager[] | null = null;

export const getCache = (): ComponentManager[] | null => cache;
export const setCache = (data: ComponentManager[]): void => {
  cache = data;
};
export const invalidateCache = (): void => {
  cache = null;
};

export const notifyAssignmentsUpdated = (): void => {
  window.dispatchEvent(new CustomEvent("assignments-updated"));
};
